module.exports = __webpack_public_path__ + "static/media/Suyog_Arlimar.44d3067e.png";